import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { UserStore } from '@seedlang/stores';
import { isPresent } from '@seedlang/utils';
import autobind from 'autobind-decorator';
import Grid from 'components/layout/grid';
import Stack from 'components/layout/stack';
import ButtonPrimary from 'components/button/button_primary';

@observer
class UserCreate extends React.Component {
  @observable showCreatedMessage = false;
  @observable message = '';

  @autobind onBulkCreate() {
    if (isPresent(this.refs.users.value)) {
      UserStore.bulkCreate({data: {users: this.refs.users.value}}, this.afterBulkCreate);
    }
  }

  @autobind onCreate() {
    if (isPresent(this.refs.password.value)) {
      UserStore.create(
        {
          data: {
            email: this.refs.email.value,
            password: this.refs.password.value,
            passwordConfirmation: this.refs.password.value,
          },
        },
      this.afterCreate);
    }
  }

  @autobind afterCreate() {
    this.refs.password.value = '';
    this.refs.email.value = '';
    this.showCreatedMessage = true;
    this.message = 'A user was successfully created.';
  }

  @autobind afterBulkCreate() {
    this.refs.users.value = '';
    this.showCreatedMessage = true;
    this.message = 'Users were successfully created.';
  }

  render() {
    return (
      <Stack gap='sm' alignItems='stretch'>
        {
          this.showCreatedMessage &&
            <div className='alert'>
              {this.message}
            </div>
        }
        <h3>Create One</h3>
        <Grid columns={[5,5,2]} gap='sm'>
          <input
            placeholder='Add a email'
            ref='email'
          />
          <input
            placeholder='Add a password'
            ref='password'
          />
          <ButtonPrimary onClick={this.onCreate}>
            Create
          </ButtonPrimary>
        </Grid>
        <h3>Create Many</h3>
        <small>format: email, (optional name) - one per line</small>
        <textarea
          ref='users'
          style={{height: 120}}
        />
        <ButtonPrimary onClick={this.onBulkCreate}>
          Create
        </ButtonPrimary>
      </Stack>
    );
  }
}

export default UserCreate;
